import { pick } from 'lodash'
// import { FILE_UPLOAD_STATE } from 'Constants'

// const { COMPLETE } = FILE_UPLOAD_STATE

export const mapStateToProps = ({ uploadFile: { files } }) => ({
  files,
})

export const handlers = (EVENTS) => ({
  publishFileUpload:
    ({ trackEvent }) =>
    (file) => {
      const { name, fields } = EVENTS.DOCUMENT_UPLOAD
      trackEvent(name, pick(file, fields))
    },
})

export const childHandlers = () => ({
  updateTrackedFiles:
    ({ files, trackedFiles, setTrackedFiles, publishFileUpload }) =>
    () => {
      return []
      // files.accepted
      //   .filter(({ meta: { status } }) => status === COMPLETE)
      //   .filter(({ id }) => !trackedFiles.includes(id))
      //   .map(({ id, file }) =>
      //     setTrackedFiles((ids) => {
      //       if (!ids.includes(id)) {
      //         ids.push(id)
      //         publishFileUpload(file)
      //       }
      //       return [].concat(ids)
      //     }),
      //   )
    },
})
